import React from 'react';
import { useRouter } from 'next/router';
import ProductCarousel from './ProductCarousel';
import ProductInfo from './ProductInfo';
import { Company, Product, Variant } from '../../../models';

interface ProductProfileProps {
  productData: Product;
  companyData: Company;
  relatedData: Product[];
}

function ProductProfile({
  productData,
  companyData,
  relatedData,
}: ProductProfileProps) {
  const router = useRouter();

  const [selectedVariant, setSelectedVariant] = React.useState(
    productData?.variants?.find(
      (v) => v?._id === router?.query?.selectedVariant
    ) ?? productData?.variants[0]
  );

  return (
    <div className="w-full flex flex-wrap ">
      <div className="w-full  lg:w-1/2">
        <ProductCarousel images={selectedVariant?.photos ?? []} />
      </div>
      <div className="w-full lg:w-1/2">
        <ProductInfo
          product={productData}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          company={companyData}
        />
      </div>
    </div>
  );
}

export default ProductProfile;
